import type { FunctionComponent } from "react";

import type { IKeywordsGroupEditorController } from "app/pages/keyword-analysis/useKeywordsGroupEditorController";
import type { IDeleteConfirmationModalProps } from "app/pages/keyword-analysis/useKeywordGroupModalWorkflow";
import type { IUserKeywordGroup } from "app/services/keyword-groups/keywordGroups.types";

import { AutocompleteDemandAnalysisEditorModal } from "./AutocompleteDemandAnalysisEditorModal";
import { AutocompleteDemandAnalysisShareModal } from "./AutocompleteDemandAnalysisShareModal";

interface IAutocompleteDemandAnalysisModalsProps {
    isShareModalOpen: boolean;
    groupToShare: IUserKeywordGroup | null;
    handleGroupShareClose: () => void;

    controller: IKeywordsGroupEditorController;
    closeEditorModal: () => void;
    handleBeforeDelete?: (group: IUserKeywordGroup) => void;
    deleteConfirmationModalProps?: IDeleteConfirmationModalProps;

    onGroupDelete?: (deletedGroup: IUserKeywordGroup) => void;
    handleSave?: (group: IUserKeywordGroup) => void;
    showGoToMonitorKeywordListButton: boolean;
}

export const AutocompleteDemandAnalysisModals: FunctionComponent<IAutocompleteDemandAnalysisModalsProps> = ({
    isShareModalOpen,
    groupToShare,
    handleGroupShareClose,
    controller,
    closeEditorModal,
    handleBeforeDelete,
    deleteConfirmationModalProps,
    onGroupDelete,
    handleSave,
    showGoToMonitorKeywordListButton,
}) => {
    return (
        <>
            <AutocompleteDemandAnalysisShareModal
                isOpen={isShareModalOpen}
                groupToShare={groupToShare}
                onClose={handleGroupShareClose}
            />
            <AutocompleteDemandAnalysisEditorModal
                controller={controller}
                closeEditorModal={closeEditorModal}
                handleBeforeDelete={handleBeforeDelete}
                deleteConfirmationModalProps={deleteConfirmationModalProps}
                onGroupDelete={onGroupDelete}
                onSave={handleSave}
                showGoToMonitorKeywordListButton={showGoToMonitorKeywordListButton}
            />
        </>
    );
};
